import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Protected() {
  const { loading, user } = useAuth();
  if (loading) return <div className="p-6 text-[#D4FF00]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
